type ProductSupportSuccessLayoutParams = {
  isCompactLayout: boolean;
  isMobileWeb: boolean;
  isNativeCompact: boolean;
};

type ProductSupportHeadingSizeParams = {
  isCompactLayout: boolean;
  isMobileWeb: boolean;
  isNativeCompact: boolean;
};

export function getHeaderSpacingClass(params: ProductSupportSuccessLayoutParams): string {
  const { isCompactLayout } = params;

  if (!isCompactLayout) {
    return 'pb-5 pt-2';
  }

  return 'pb-2 pt-3';
}

export function getSubtitleClass(params: ProductSupportSuccessLayoutParams): string {
  const { isCompactLayout, isMobileWeb } = params;

  if (!isCompactLayout) {
    return 'mt-2 max-w-xl text-base leading-relaxed';
  }

  if (isMobileWeb) {
    return 'mb-1 mt-1 max-w-[24rem] font-normal leading-6';
  }

  return 'mb-2 mt-1 max-w-[24rem] font-normal leading-5';
}

export function getSubtitleTextStyle(
  params: ProductSupportSuccessLayoutParams
): { fontSize: number } | undefined {
  const { isCompactLayout, isMobileWeb } = params;

  if (!isCompactLayout) {
    return undefined;
  }

  if (isMobileWeb) {
    return { fontSize: 14 };
  }

  return { fontSize: 13 };
}

export function getCardContainerClass(
  params: ProductSupportSuccessLayoutParams
): string | undefined {
  const { isCompactLayout, isMobileWeb } = params;

  if (!isCompactLayout) {
    return undefined;
  }

  if (isMobileWeb) {
    return 'mt-2';
  }

  return 'mt-5';
}

export function getCardPaddingClass(params: ProductSupportSuccessLayoutParams): string {
  const { isCompactLayout } = params;

  if (!isCompactLayout) {
    return 'p-6';
  }

  return 'p-3';
}

export function getContentGapClass(params: ProductSupportSuccessLayoutParams): string {
  const { isCompactLayout } = params;

  if (!isCompactLayout) {
    return 'gap-5';
  }

  return 'gap-2';
}

export function getCardHeadingSize(params: ProductSupportHeadingSizeParams): string {
  const { isCompactLayout, isMobileWeb } = params;

  if (!isCompactLayout) {
    return 'h2-xl';
  }

  if (isMobileWeb) {
    return 'lg';
  }

  return 'md';
}
